import React from 'react';
import { Field } from 'formik';
import { Box } from 'lmc-ui-library';
import TextField from 'modules/af_cm_ui_kit/components/TextField/TextField';
import { FIELDS, FIELDS_LABELS } from '../types';
import { TermsOfBusinessProps } from './types';

import styles from '../profile.module.scss';

const TermsOfBusiness: React.FC<TermsOfBusinessProps> = ({ title, termsOfBusinessUrl }) => {
  return (
    <Box title={title} className={styles.box}>
      <Box.Content>
        <Field component={TextField} name={FIELDS.TOB_SIGNED_BY} title={FIELDS_LABELS.TOB_SIGNED_BY} disabled={true} />
        <Field
          component={TextField}
          name={FIELDS.TOB_SIGNED_DATE}
          title={FIELDS_LABELS.TOB_SIGNED_DATE}
          disabled={true}
        />
        <Field component={TextField} name={FIELDS.TOB_VERSION} title={FIELDS_LABELS.TOB_VERSION} disabled={true} />
        {termsOfBusinessUrl && (
          <>
            <hr className={styles.hr} />

            <a
              className={styles.link}
              href={termsOfBusinessUrl ? termsOfBusinessUrl : '/'}
              target="_blank"
              rel="noopener noreferrer">
              View terms of business
            </a>
          </>
        )}
      </Box.Content>
    </Box>
  );
};

export default TermsOfBusiness;
